import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import DataSnackbar from './DataSnackbar';
import {
  TOUR_DIALOG_TYPE,
} from '../../ComponentTypes';

class AppMain extends React.PureComponent {
  static propTypes = {
    configuration: PropTypes.shape({
      apiClient: PropTypes.func.isRequired,
      getServices: PropTypes.func.isRequired,
      globalProps: PropTypes.shape({}),
    }).isRequired,
    viewService: PropTypes.shape({
      getComponent: PropTypes.func.isRequired,
    }).isRequired,
    authService: PropTypes.shape({
      isSkipTour: PropTypes.func,
      setSkipTour: PropTypes.func,
    }).isRequired,
    query: PropTypes.shape({}),
    startLoading: PropTypes.func,
    stopLoading: PropTypes.func,
    history: PropTypes.shape({ push: PropTypes.func }).isRequired,
    location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired,
    Content: PropTypes.func.isRequired,
    jsonConfig: PropTypes.shape({
      tour: PropTypes.shape({}),
    }),
    username: PropTypes.string,
    profile: PropTypes.shape({}),
  }

  static defaultProps = {
    query: undefined,
    startLoading: undefined,
    stopLoading: undefined,
    jsonConfig: undefined,
    username: undefined,
    profile: undefined,
  }

  constructor(props) {
    super(props);
    const { jsonConfig, viewService, authService } = props;
    this.TourDialog = jsonConfig.tour && viewService.getComponent(TOUR_DIALOG_TYPE);
    this.state = {
      showDataSnackbar: false,
      dataResultOnSnackbar: undefined,
      tourOpen: this.TourDialog && !authService.isSkipTour(props.profile),
      redirectToLocation: false,
      locationToRestore: undefined,
    };

    // Bindings
    this.handleCloseDataSnackbar = this.handleCloseDataSnackbar.bind(this);
    this.handleSnackbarMessage = this.handleSnackbarMessage.bind(this);
    this.onEditKeys = this.onEditKeys.bind(this);
    this.handleTakeTour = this.handleTakeTour.bind(this);
    this.handleCloseTour = this.handleCloseTour.bind(this);

    this.apiClient = props.configuration.apiClient;
    this.globalProps = props.configuration.globalProps || {};

    this.dataSnackbarQueue = [];
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;

    this.props.configuration.getServices().forEach((service) => {
      if (service.appDidMount) {
        service.appDidMount();
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (this.TourDialog && (this.props.username !== prevProps.username)) {
      if (!this.props.authService.isSkipTour(this.props.profile)) {
        this.setState({ tourOpen: true });
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.props.configuration.getServices().forEach((service) => {
      if (service.appWillUnmount) {
        service.appWillUnmount();
      }
    });
  }

  handleCloseDataSnackbar() {
    this.setState({
      showDataSnackbar: false,
    });
    if (this.dataSnackbarQueue.length > 0) {
      setTimeout(() => {
        this.setState({
          dataResultOnSnackbar: this.dataSnackbarQueue.shift(),
          showDataSnackbar: true,
        });
      }, 500);
      // this.setState({
      //   dataResultOnSnackbar: this.dataSnackbarQueue.shift(),
      //   showDataSnackbar: true,
      // });
    }
  }

  onEditKeys() {
    this.props.history.push('/userkeys', { referrer: this.props.location });
  }

  handleSnackbarMessage(messageObj) {
    if (!this.mounted) {
      console.log(messageObj.message);
    } else if (this.state.showDataSnackbar) {
      this.dataSnackbarQueue.push(messageObj);
    } else {
      this.setState({ showDataSnackbar: true, dataResultOnSnackbar: messageObj });
    }
  }

  handleTakeTour() {
    this.setState({ tourOpen: true });
  }

  handleCloseTour(gotIt, locationToRestore) {
    if (gotIt) {
      this.props.authService.setSkipTour(this.props.profile, true);
    }
    const { location } = this.props;
    const hasLocationChanged = locationToRestore && (location !== locationToRestore);
    this.setState({
      tourOpen: false,
      redirectToLocation: hasLocationChanged,
      locationToRestore,
    }, () => {
      if (hasLocationChanged) {
        this.setState({ redirectToLocation: false, locationToRestore: null });
      }
    });
  }

  render() {
    const { Content, jsonConfig } = this.props;
    // this.props is given a location property by the enclosing router to this App container.
    // Propagating the location property allows for child components to detect location changes
    // for re-rendering if other properties are not used by these components.
    // Details here: https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
    const props = {
      ...this.props,
      ...this.globalProps,
      onEditKeys: this.onEditKeys,
      apiClient: this.apiClient,
      onSnackbarMessage: this.handleSnackbarMessage,
    };
    const { tourOpen, redirectToLocation } = this.state;
    if (this.TourDialog) {
      props.onTakeTour = this.handleTakeTour;
    }
    if (redirectToLocation) {
      return <Redirect to={this.state.locationToRestore} />;
    }

    return (
      <React.Fragment>
        <Content {...props} />
        {this.state.showDataSnackbar && (
          <DataSnackbar
            dataResult={this.state.dataResultOnSnackbar}
            open={this.state.showDataSnackbar}
            onClose={this.handleCloseDataSnackbar}
          />
        )}
        {this.TourDialog && tourOpen && (
          <this.TourDialog
            {...props}
            configuration={jsonConfig.tour}
            onClose={this.handleCloseTour}
            open={tourOpen}
          />
        )}
      </React.Fragment>
    );
  }
}

export default AppMain;
